import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';
import { CookieConsent } from '@/components/CookieConsent';
import { Toaster } from '@/components/ui/sonner';
import ScrollToTop from '@/components/ScrollToTop';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Technologies from '@/pages/Technologies';
import TechnologyDetail from '@/pages/TechnologyDetail';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Careers from '@/pages/Careers';
import Contact from '@/pages/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <ScrollToTop />

        <Navigation />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/technologies/:id" element={<TechnologyDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />
        <WhatsAppFloat />
        <CookieConsent />
        <Toaster position="top-right" />

      </BrowserRouter>
    </div>
  );
}

export default App;